export default __webpack_public_path__ + "static/media/LinkedinH.365cae21.svg";